import { Controller } from "@hotwired/stimulus";

// Adds/removes question rows on the ritual preset form without a server
// round-trip. Each row submits a `ritual_preset[questions][]` label plus a
// parallel `ritual_preset[question_types][]` ("text"/"check") carried by a
// hidden field; removing a row drops both fields together, and an added blank
// row is stripped server-side (RitualPresetsController#preset_params).
export default class extends Controller {
  static targets = [ "template", "rows", "row", "typeField" ]

  add(event) {
    event?.preventDefault()
    const content = this.templateTarget.content.cloneNode(true)
    this.rowsTarget.appendChild(content)
  }

  remove(event) {
    event?.preventDefault()
    const row = event.target.closest("[data-ritual-questions-target='row']")
    row?.remove()
  }

  // The row's checkbox is visual only; the hidden type field is what gets
  // submitted, so keep it in sync with the toggle state. Delegated on the
  // controller root because cloned template rows don't get their own Stimulus
  // action bindings.
  toggleType(event) {
    if (event.target.type !== "checkbox") return
    const row = event.target.closest("[data-ritual-questions-target='row']")
    const typeField = row?.querySelector("[data-ritual-questions-target='typeField']")
    if (typeField) typeField.value = event.target.checked ? "check" : "text"
  }
}
